module.exports = __webpack_public_path__ + "img/manual-receive-04-reject-dialog.2b248adf.png";